import * as React from 'react'
import { PrimaryButton } from '@paytrace/pt-skel/Component'

export interface ManageEnhancedDataBannerProps {
  title: string
  subText: string | React.ReactNode
  buttonText: string
  onButtonClick: () => void
}

// I made this very generic, we could utilize this for other parts as well. Will need to rename if we do
export function ManageEnhancedDataBanner ({
  title,
  subText,
  buttonText,
  onButtonClick,
}: ManageEnhancedDataBannerProps) {
  return (
    <div className="warning med-banner">
      <h2>
        {title}
      </h2>
      <p style={{ fontSize: '16px' }}>
        {subText}
      </p>
      <PrimaryButton type="button" onClick={onButtonClick} style={{ border: 'none' }}>
        {buttonText}
      </PrimaryButton>
    </div>
  )
}
